import { useCallback, useEffect, useState } from "react"
import { consentStatus, observeConsentStatusChange } from "@theconversation/shared-libraries/Didomi"
import { isEnabled } from "common/components/Didomi"

/**
 * Hook to get the Didomi consent status and observe changes in Didomi preferences.
 */
export const useConsent = (vendorId: string, purpose: string): boolean => {
  const [consent, setConsent] = useState<boolean>(false)

  const handler = useCallback(async () => {
    if (!isEnabled()) {
      setConsent(true)
      return
    }

    try {
      const consent = await consentStatus({ vendorId, purpose })
      setConsent(consent)
    } catch (error) {
      console.warn("Error fetching consent status:", error)
      setConsent(false)
    }
  }, [vendorId, purpose])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    void handler()
    observeConsentStatusChange(handler)
  }, [handler])

  return consent
}
